const KEYVALUESTORE_ACTIONS = {
  KEY_UPDATED: 'KEY_UPDATED',
  KEY_REMOVED: 'KEY_REMOVED'
};

const keyRemovedAction = (key) => {
  return {
    type: KEYVALUESTORE_ACTIONS.KEY_REMOVED,
    payload: { key }
  };
};

const keyUpdatedAction = (key, value) => {
  return {
    type: KEYVALUESTORE_ACTIONS.KEY_UPDATED,
    payload: { key, value }
  };
};

export { keyRemovedAction, keyUpdatedAction };

export default KEYVALUESTORE_ACTIONS;
